export default "__VITE_ASSET__7TMFAYdK__"